import type { FC } from 'react';
import React, { useEffect, useState } from 'react';

import type { ILinkAdvSummaryProps } from '../models';

export const LinkAdv: FC<ILinkAdvSummaryProps> = ({
    children,
    advCodes = ['platformId'],
    href,
    getNewHref,
    Link,
    ...restProps
}) => {
    const [newHref, setNewHref] = useState(href);

    useEffect(() => {
        setNewHref(href ? getNewHref({ advCodes, href }) : href);
    }, [href, advCodes, getNewHref]);

    return (
        <Link href={newHref} {...restProps}>
            {children}
        </Link>
    );
};
